import { markBlockedIfIpNotAllowed } from "@/lib/api-client";
import { isOwnApiUrl } from "@/lib/preview-fetch";

/**
 * ファイル URL を fetch するときの初期化オプション。自前 API オリジンのときのみ
 * Cookie を送る。presigned S3 URL に credentials を付けるとワイルドカード CORS で
 * 弾かれるため付けない。
 */
export function fileFetchInit(url: string): RequestInit {
	return isOwnApiUrl(url) ? { credentials: "include" } : {};
}

/** ファイル URL を fetch する。接続元 IP 制限による拒否なら apiFetch と同じく記録する。 */
export async function fetchFile(
	url: string,
	init: RequestInit = fileFetchInit(url),
): Promise<Response> {
	const res = await fetch(url, init);
	await markBlockedIfIpNotAllowed(res);
	return res;
}

/**
 * 指定した URL のファイルをブラウザでダウンロードする。
 * ファイル名はサーバー側のレスポンスヘッダ (Content-Disposition: attachment) が
 * 決めるため、`download` 属性は空文字でよい。空でも「ナビゲーションではなく
 * ダウンロードである」とブラウザに伝わり、Safari が保存ダイアログを出すのを防げる。
 * 呼び出し側は `download: true` を指定した URL を渡すこと。
 */
export function downloadFile(url: string): void {
	const link = document.createElement("a");
	link.href = url;
	link.download = "";
	document.body.appendChild(link);
	link.click();
	link.remove();
}

/** メモリ上のバイナリを指定したファイル名でダウンロードする。 */
export function downloadBlob(blob: Blob, filename: string): void {
	const url = URL.createObjectURL(blob);
	const link = document.createElement("a");
	link.href = url;
	link.download = filename;
	document.body.appendChild(link);
	link.click();
	link.remove();
	setTimeout(() => URL.revokeObjectURL(url), 0);
}
